import { render, staticRenderFns } from "./DraggableWatchlistDropdown.vue?vue&type=template&id=52da4af0&scoped=true"
import script from "./DraggableWatchlistDropdown.vue?vue&type=script&lang=js"
export * from "./DraggableWatchlistDropdown.vue?vue&type=script&lang=js"
import style0 from "./DraggableWatchlistDropdown.vue?vue&type=style&index=0&id=52da4af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da4af0",
  null
  
)

export default component.exports